import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as TakeOutOrderStore from './TakeOutOrderStore';
import { Command } from 'pos/common';
import { Permission, Res } from 'core/api';
import { TakeOutOrderFacade } from 'pos/facades';
import getDeliveryPerson from './getDeliveryPerson';
import tryToGetLocatedAddress from './tryToGetLocatedAddress';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		changeTakeOutOrderDeliveryPerson: (orderId: number, deliveryPerson: string | undefined, onNoDeliveryPersons: 'WARN_IF_NO_DELIVERY_PERSONS' | 'IGNORE_IF_NO_DELIVERY_PERSONS') => Promise<Result>
	}
}

Command.register('changeTakeOutOrderDeliveryPerson', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_ChangeDeliveryPerson), Preconditions.ensureIsNotLite), async (orderId: number, deliveryPerson: string | undefined, onNoDeliveryPersons: 'WARN_IF_NO_DELIVERY_PERSONS' | 'IGNORE_IF_NO_DELIVERY_PERSONS'): Promise<Result> => {

	const deliveryPersonStatuses = await TakeOutOrderFacade.getDeliveryPersonStatuses();
	if (deliveryPersonStatuses.length === 0) {

		if (onNoDeliveryPersons === 'IGNORE_IF_NO_DELIVERY_PERSONS')
			return Result.ok();

		await Message.show(Res.Msg.MSG_NOT_EXISTS_DELIVERY_PERSONS());
		return Result.error();
	}

	const deliveryPersonSelected = deliveryPersonStatuses.find(dp => dp.UserName === deliveryPerson);

	const selectedDeliveryPersonResult = await getDeliveryPerson(deliveryPersonStatuses, deliveryPersonSelected);
	if (!selectedDeliveryPersonResult.ok)
		return Result.error();

	if (selectedDeliveryPersonResult.value.UseDeliveryPlatform) {
		const localizeResult = await localizeAddressIfNedded(orderId);
		if (!localizeResult.ok)
			return Result.error();
	}

	return await TakeOutOrderStore.changeDeliveryPerson(orderId, selectedDeliveryPersonResult.value.UserId);
});

async function localizeAddressIfNedded(orderId: number): Promise<Result> {
	const { deliveryAddress, location } = await TakeOutOrderStore.getDeliveryLocation(orderId);
	if (location === null) {

		const result = await tryToGetLocatedAddress(deliveryAddress);
		if (!result.ok)
			return Result.error();

		const { updatedAddress, location } = result.value;
		const updateDeliveryAddressResult = await TakeOutOrderStore.updateDeliveryAddress(orderId, updatedAddress, location);
		if (!updateDeliveryAddressResult.ok)
			return Result.error();
	}

	return Result.ok();
}
